import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { SEARCH_PAGE_META } from 'lib/enums/search';
import { getPageTitle } from 'store/search/searchSelectors';

const ListSearchMeta = React.memo(() => {
  const pageTitle = useSelector(getPageTitle);
  return <Helmet title={pageTitle} meta={SEARCH_PAGE_META} />;
});

ListSearchMeta.displayName = 'ListSearchMeta';

export default ListSearchMeta;
